import { Quality as Quality1 } from "@/components/report/Quality";
import Quality2 from "@/components/report/Quality2";
import {
  Quality2Response,
  QualityResponse,
  ReportPageBaseProps,
} from "@/components/report/types";
import { useAxios } from "@/utils/axios";
import { usePageUserType } from "@/utils/router";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

export function QualityPage({ setIndicator }: ReportPageBaseProps) {
  const { uuid } = useParams();
  const userType = usePageUserType();
  const axios = useAxios();
  const [data, setData] = useState<{ publish_version: string } | null>(null);
  useEffect(() => {
    (async () => {
      const response = await axios.get(`/api/report/${uuid}/quality`);
      setData(response.data);
      setIndicator(false);
    })();
  }, [axios, uuid, setIndicator]);

  if (uuid == null || data == null) return <></>;

  switch (data.publish_version) {
    case "1.0":
    case "1.1":
      // PDF版
      return <></>;
    case "2.0":
    case "3.0":
    case "3.1":
      // 旧Webレポート
      return (
        <Quality1
          data={data as QualityResponse}
          userType={userType}
          uuid={uuid}
        />
      );
    case "4.0":
    default:
      // Webレポート改善版
      return (
        <Quality2
          data={data as Quality2Response}
          userType={userType}
          uuid={uuid}
        />
      );
  }
}
